import styled from "styled-components";

import { Link } from "ds/Button";

export const Section = styled.div`
  color: var(--section-ebony-color, var(--ebony));
`;

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const Info = styled.p`
  font-size: 14px;
`;

export const MoreInfo = styled.div`
  display: flex;
  font-size: 14px;
  margin-top: 20px;

  svg {
    color: var(--icon-slate-color, var(--slate));
    margin-right: 10px;
  }

  a {
    margin-left: 0.6ch;
    margin-top: -2px;
  }
`;

export const LearnMoreLink = styled(Link)`
  color: var(--mode-text-primary-default);
`;
